import * as Types from '../../../generated/types';

import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type AddTemplateResultFragment = { __typename: 'Template', id: string, legacyId: number, name?: string | null, state: Types.TemplateState, articleId?: string | null, type: Types.TemplateType, public: boolean, comment?: string | null, galleryImage?: { __typename: 'DataObject', id: string } | null, organization: { __typename: 'Organization', name?: string | null, id: string, legacyId: number }, latestRevision?: { __typename: 'TemplateRevision', id: string, legacyId: number, completed: boolean, createdAt: string, graph?: any | null, createdBy?: { __typename: 'User', id: string } | null, renderedImages: Array<{ __typename: 'DataObject', id: string }> } | null };

export type AddTemplateCreateTemplateMutationVariables = Types.Exact<{
  input: Types.MutationCreateTemplateInput;
}>;


export type AddTemplateCreateTemplateMutation = { __typename: 'Mutation', createTemplate: { __typename: 'Template', id: string, legacyId: number, name?: string | null, state: Types.TemplateState, articleId?: string | null, type: Types.TemplateType, public: boolean, comment?: string | null, galleryImage?: { __typename: 'DataObject', id: string } | null, organization: { __typename: 'Organization', name?: string | null, id: string, legacyId: number }, latestRevision?: { __typename: 'TemplateRevision', id: string, legacyId: number, completed: boolean, createdAt: string, graph?: any | null, createdBy?: { __typename: 'User', id: string } | null, renderedImages: Array<{ __typename: 'DataObject', id: string }> } | null } };

export type AddTemplateCreateTemplateRevisionMutationVariables = Types.Exact<{
  input: Types.MutationCreateTemplateRevisionInput;
}>;


export type AddTemplateCreateTemplateRevisionMutation = { __typename: 'Mutation', createTemplateRevision: { __typename: 'TemplateRevision', id: string, legacyId: number } };

export type AddTemplateUpdateTemplateRevisionMutationVariables = Types.Exact<{
  input: Types.MutationUpdateTemplateRevisionInput;
}>;


export type AddTemplateUpdateTemplateRevisionMutation = { __typename: 'Mutation', updateTemplateRevision: { __typename: 'TemplateRevision', id: string } };

export type AddTemplateDeleteTemplateMutationVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type AddTemplateDeleteTemplateMutation = { __typename: 'Mutation', deleteTemplate?: any | null };

export type AddTemplateDeleteTemplateRevisionMutationVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type AddTemplateDeleteTemplateRevisionMutation = { __typename: 'Mutation', deleteTemplateRevision?: any | null };

export const AddTemplateResultFragmentDoc = gql`
    fragment AddTemplateResult on Template {
  id
  legacyId
  name
  state
  articleId
  galleryImage {
    id
  }
  type
  public
  comment
  organization {
    name
    id
    legacyId
  }
  latestRevision {
    id
    legacyId
    completed
    createdAt
    graph
    createdBy {
      id
    }
    renderedImages(take: 4) {
      id
    }
  }
}
    `;
export const AddTemplateCreateTemplateDocument = gql`
    mutation addTemplateCreateTemplate($input: MutationCreateTemplateInput!) {
  createTemplate(input: $input) {
    ...AddTemplateResult
  }
}
    ${AddTemplateResultFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class AddTemplateCreateTemplateGQL extends Apollo.Mutation<AddTemplateCreateTemplateMutation, AddTemplateCreateTemplateMutationVariables> {
    override document = AddTemplateCreateTemplateDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AddTemplateCreateTemplateRevisionDocument = gql`
    mutation addTemplateCreateTemplateRevision($input: MutationCreateTemplateRevisionInput!) {
  createTemplateRevision(input: $input) {
    id
    legacyId
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AddTemplateCreateTemplateRevisionGQL extends Apollo.Mutation<AddTemplateCreateTemplateRevisionMutation, AddTemplateCreateTemplateRevisionMutationVariables> {
    override document = AddTemplateCreateTemplateRevisionDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AddTemplateUpdateTemplateRevisionDocument = gql`
    mutation addTemplateUpdateTemplateRevision($input: MutationUpdateTemplateRevisionInput!) {
  updateTemplateRevision(input: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AddTemplateUpdateTemplateRevisionGQL extends Apollo.Mutation<AddTemplateUpdateTemplateRevisionMutation, AddTemplateUpdateTemplateRevisionMutationVariables> {
    override document = AddTemplateUpdateTemplateRevisionDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AddTemplateDeleteTemplateDocument = gql`
    mutation addTemplateDeleteTemplate($id: ID!) {
  deleteTemplate(id: $id)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AddTemplateDeleteTemplateGQL extends Apollo.Mutation<AddTemplateDeleteTemplateMutation, AddTemplateDeleteTemplateMutationVariables> {
    override document = AddTemplateDeleteTemplateDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AddTemplateDeleteTemplateRevisionDocument = gql`
    mutation addTemplateDeleteTemplateRevision($id: ID!) {
  deleteTemplateRevision(id: $id)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AddTemplateDeleteTemplateRevisionGQL extends Apollo.Mutation<AddTemplateDeleteTemplateRevisionMutation, AddTemplateDeleteTemplateRevisionMutationVariables> {
    override document = AddTemplateDeleteTemplateRevisionDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }